<template>
  <div class="bg-dark-type-1">
    <div class="bg-white">
      <div class="w-full py-10 lg:px-32">
        <div class="w-full px-6">
          <article class="page sans">
            <header>
              <h1 class="page-title">Privacy Policy</h1>
            </header>
            <p>
              <strong>Updated February 3rd, 2022</strong>
            </p>
            <div class="page-body">
              <h2>Introduction</h2>
              <p>
                Shuttlers Metropolitan Mobility Company Limited
                (“<strong>Shuttlers</strong>” or “<strong>Us</strong>” or
                “<strong>We</strong>” or “<strong>Our</strong>”) is a limited
                liability company incorporated under the laws of the Federal
                Republic of Nigeria, with registration number 1412883 and having
                its registered office address at 10a, Ojora Close, off Idowu
                Martins, Victoria Island, Lagos. We are dedicated to protecting
                the confidentiality and privacy of personally identifiable
                information entrusted to Us (“<strong>Personal Data</strong>”).
                As part of that fundamental obligation, We are committed to
                protecting the use of the Personal Data which We collect on
                <a class="hover:text-active" href="https://www.shuttlers.ng"
                  >https://www.shuttlers.ng</a
                >
                and Shuttlers' application software (the
                “<strong>App</strong>”). The App is an information and booking
                reservations platform for mobility, transportation and
                chartering of vehicles (“<strong>Services</strong>”). This
                privacy policy (“<strong>Privacy Statement</strong>”) sets out
                the basis upon which We will process, store, and disclose any
                Personal Data that is provided voluntarily by users of the App
                (“<strong>Data Subject</strong>” or “<strong>you</strong>” or
                “<strong>your</strong>”) in connection with the Services that We
                offer.
              </p>
              <br />
              <p>
                We note that the Nigeria Data Privacy Regulations (NDPR)
                distinguishes between entities that are “controllers” of
                Personal Data and entities that “process” Personal Data. We note
                that We are a “Data Controller” where We determine the purposes
                for and the manner in which Personal Data is processed or is to
                be processed and We are a “Processor” for those Services where
                We only use Personal Data that is requested by other Data
                Controllers.
              </p>
              <br />
              <p>
                Where We make decisions on how Personal Data is used in
                connection with Our Services (where We are acting as a
                controller), We are responsible for the obligations of a
                “Controller” under the NDPR in connection with the processing of
                Personal Data - for example, We use this Privacy Statement and
                other notices to provide you with information about Our use of
                personal information, as required by the NDPR. Where We only use
                Personal Data requested by other Data Controllers (where We are
                acting as a processor), those other Data Controllers are
                similarly responsible for the obligations of a “Controller”
                under applicable laws in connection with the processing of
                personal information, and, if you are using Our Services through
                those other Controllers, you should contact them if you have
                questions or concerns about the processing of your personal
                information or compliance with the NDPR and other applicable
                laws.
              </p>
              <br />
              <p>
                This Privacy Statement may change from time to time. Unless
                otherwise stated, any updates to this Privacy Statement become
                effective when We post the updates on Our website and App. Your
                continued use of the App for Our Services following an update to
                the Privacy Statement means that you accept the updated Privacy
                Statement.
              </p>
              <br />

              <h2>Your Privacy Rights</h2>
              <p>
                This Privacy Statement describes your privacy rights regarding
                Our collection, use, storage, sharing and protection of your
                Personal Data. It applies to Our website, App and all other
                related applications, services, tools and physical contact with
                Us regardless of how you access or use them.
              </p>
              <br />
              <p>You have the following rights:</p>
              <ol class="list-roman">
                <li>
                  right to request from Us access to and rectification or
                  erasure of your Personal Data;
                </li>
                <li>
                  right to restrict processing or object to processing of your
                  Personal Data;
                </li>
                <li>right to data portability;</li>
                <li>
                  right to withdraw consent at any time, without affecting the
                  lawfulness of processing based on consent before its
                  withdrawal;
                </li>
                <li>right to lodge a complaint with the relevant authority.</li>
              </ol>
              <br />
              <p>
                In the event that you wish to: (i) access your Personal Data
                processed by Us in accordance with this Privacy Statement; (ii)
                ask any questions at all regarding Our use of your Personal
                Data; (iii) rectify your Personal Data processed by Us in
                accordance with this Privacy Statement; (iv) restrict or object
                to the processing of your Personal Data; (v) withdraw your
                consent to Our processing of your Personal Data; or (vi) request
                for data portability, please reach out to Us at
                <a class="text-active" href="mailto:info@shuttlers.ng"
                  >info@shuttlers.ng</a
                >.
              </p>
              <br />
              <p>
                We carefully analyze what types of Personal Data We need to
                provide Our Services, and We try to limit the Personal Data We
                collect to only what We really need.
              </p>
              <br />
              <p>
                Where possible, We delete or anonymize Personal Data when We no
                longer need it. We will retain your Personal Data for the
                duration of Our Services to you and afterwards for as long as is
                necessary and relevant for purposes permitted by applicable laws
                and regulations. Where We no longer need your Personal Data, We
                will dispose of it in a secure manner.
              </p>
              <br />
              <p>
                If you have created a username, identification code, password or
                any other piece of information as part of Our access security
                measures, you must treat such information as confidential, and
                you must not disclose it to any third party. We reserve the
                right to disable any user identification code or password,
                whether chosen by you or allocated by Us, at any time, if in Our
                opinion you have failed to comply with any of the provisions of
                these conditions. If you know or suspect that anyone other than
                you know or has access to your security information, you must
                promptly notify Us at
                <a class="text-active" href="mailto:info@shuttlers.ng"
                  >info@shuttlers.ng</a
                >.
              </p>
              <br />

              <h2>Your Consent</h2>
              <p>
                Please read this Privacy Statement very carefully. If you do not
                wish to be bound by the provisions of this Privacy Statement,
                you should not access the App or sign up for Our Services. By
                using the App, and by signing up for Our Services, you hereby
                confirm that you have read, understand, and agree to be bound by
                the Privacy Statement.
              </p>
              <br />
              <p>
                Additionally, please note that the option to sign up on the App
                is intended solely for persons who are 13 (thirteen) years of
                age or older, and any registration by, use of or access to the
                Services by any person under 13 (thirteen) is unauthorized and
                in violation of this Privacy Statement. Shuttlers does not
                knowingly collect Personal Data from children under the age of
                13 (thirteen). We therefore also ask you, if you are under the
                age of 13 (thirteen), please do not send us or submit your
                Personal Data.
              </p>
              <br />
              <p>
                You hereby give Us consent to the collection and processing of
                your Personal Data for the purpose of providing the Services.
                You hereby certify that all the information provided by you are
                true and correct and that any misrepresentations or falsity,
                whether intentional or not, therein will be considered as an act
                to defraud Us and Our partners. You authorize Us to verify and
                investigate the above statements/information as may be required,
                from the references provided and other reasonable sources. For
                this purpose, you hereby waive your rights on the
                confidentiality of client information and expressly consent to
                the processing of any Personal Data and records relating to you
                that might be obtained from third parties, including government
                agencies, your employer, business associates, and other
                entities.
              </p>
              <br />
              <h2>What Kind Of Personal Data Do We Collect?</h2>

              <p>
                This section details the Personal Data We may collect about you.
                We explain why, and how, We use it in later sections. If you
                decide to create an account or enquire about one of Our products
                or Services, We'll ask You to provide Us with some specific
                information, for example:
                <strong>Basic personal details</strong> - such as name,
                surnames, passport photograph, age, gender and date of birth;
                <strong>Personal contact details</strong> - such as home
                address, home phone number, mobile phone number, and email
                address; <strong>Work details</strong> - such as job title,
                department, company name, company address;
                <strong>Log in details</strong> - such as username and password;
                <strong>Usage Information and Browsing History</strong> - such
                as usage metrics (including usage rates, occurrences of
                technical errors, diagnostic reports, settings preferences,
                content and advertising interactions; banking details -account
                number; <strong>Service details</strong> - such as pickup
                location and destination. We may also collect additional
                information involving Your opinion of Our products and Services
                and Your preferences regarding other services such as newsletter
                subscription, preferred routes, and commuting frequency.
              </p>
              <br />
              <p>
                Information about your computer and mobile device hardware and
                software may be automatically collected by Us. This information
                can include: your IP address and location, browser and device
                name, type and version, operating system type and version,
                language preferences, domain names, the information you search
                for on the Services, access times and dates, referring website
                addresses and other statistics. This information is used for the
                operation of the Service, to maintain quality of the Service,
                and to provide general statistics regarding use of the App.
              </p>
              <br />
              <p>
                Please keep in mind that if you directly disclose Personal Data
                through Shuttlers public message boards, this information may be
                collected and used by third parties.
              </p>
              <br />
              <p>
                Our website and App may contain links to other resources not
                owned or controlled by Us and as such, We encourage you to
                review the privacy statements of websites you choose to link
                from Our website and App so that you can understand how those
                websites collect, use and share your information. Please bear in
                mind that Shuttlers is not responsible and will not be liable
                for the privacy practices or other content of such other
                resources or third parties.
              </p>
              <br />
              <h2>What is the Source of Personal Data We Collect?</h2>
              <p>
                We may collect Personal Data about you either directly from You,
                from certain third parties (such as your employer or the
                subscriber providing access to Our Services), or from other
                sources (such as publicly available sources) when you:
              </p>
              <ul class="list-disc">
                <li>Search for, subscribe to Our Services.</li>
                <li>Use Our Services or otherwise interact with Us.</li>
                <li>Create or maintain a profile or account with Us.</li>
                <li>
                  Purchase, use, or otherwise interact with content, products,
                  or services from third party providers who have a relationship
                  with Us.
                </li>
                <li>Create, post, or submit user content on Our Services.</li>
                <li>Register for or attend one of Our events or locations.</li>
                <li>Request or sign up for information.</li>
                <li>
                  Communicate with Us by phone, email, chat, in person, or
                  otherwise.
                </li>
                <li>
                  Complete a questionnaire, survey, support ticket, or other
                  information request form.
                </li>
                <li>
                  When you express an interest in working with Us or apply for a
                  job or position with Us.
                </li>
              </ul>
              <br />
              <p>
                In some circumstances, We may collect Personal Data about you
                from Our partners or from publicly available websites to help Us
                better understand Our audience and enhance the relevance of Our
                content. We collect Personal Data about you from third parties,
                such as:
              </p>
              <ul class="list-disc">
                <li>
                  Your organization and others with whom you have a relationship
                  that provide or publish Personal Data related to you, such as
                  from Our customers when they arrange access to Our Services
                  for you or from others when they create, post, or submit user
                  content on Our Services that may include your Personal Data.
                </li>
                <li>
                  Professional or industry organizations and
                  certification/licensure agencies that provide or publish
                  Personal Data related to you.
                </li>
                <li>
                  Third parties and affiliates who resell or integrate with Our
                  Services.
                </li>
                <li>
                  Service providers and business partners who work with Us in
                  relation to Our Services and that We may utilize to deliver
                  certain content, products, or services or to enhance your
                  experience.
                </li>
                <li>
                  Marketing, sales generation, and recruiting business partners.
                </li>
                <li>
                  Government agencies and others who release or publish public
                  records.
                </li>
                <li>
                  Other publicly or generally available sources, such as social
                  media sites, public and online websites, open databases, the
                  corporate affairs commission, and data in the public domain.
                </li>
              </ul>
              <br />
              <p>
                We use cookies (and similar technologies) and analytics tools to
                collect information about You. This information can be used to
                improve the performance of the site, make advertising more
                relevant and enhance your user experience, such as
                <strong>Your location</strong> - We use cookies to display
                information that is most relevant to your location.
                <strong>Your usage</strong> - We use cookies to understand how
                Our customers use Our App and interact with Our communications.
                For example, We use technology on Our App, which records user
                movements, including page scrolling, clicks and text entered.
                (It does not record payment details). This helps Us to identify
                usability issues and improve the assistance We can provide to
                users and is also used for aggregated and statistical reporting
                purposes. <strong>Your device</strong> - We use cookies to
                understand what type of device you are using to show you the
                best version of the site. For instance, if you visit Our website
                on a mobile device, Our technology will ensure that you see a
                version that is optimized for mobile viewing and interaction.
                <strong>Your engagement with advertisements</strong> - We use
                cookies to understand what advertisements you have been shown,
                or clicked on, to bill Our advertising partners, and to present
                you with advertisements that are more relevant to you.
              </p>
              <br />
              <p>
                Cookies are small files placed on your computer's hard drive
                that enables the website and App to identify your computer as
                you view different pages. Cookies allow websites and
                applications to store your preferences in order to present
                contents, options or functions that are specific to you. Like
                most interactive websites, Our website uses cookies to enable
                the tracking of your activity for the duration of a session.
              </p>
              <br />
              <h2>Lawful Basis for Processing</h2>
              <p>
                We only process Personal Data where We have a lawful basis for
                doing so, such as the following:
              </p>
              <ol class="list-decimal">
                <li>
                  <strong>User consent</strong> - This is where you have given
                  Us explicit permission to process Personal Data for a given
                  purpose. For example, if you create a profile on Our App, We
                  may additionally ask you to consent to Us processing your
                  Personal Data.
                </li>
                <li>
                  <strong>Contractual necessity</strong> - This is where We have
                  to process Personal Data to meet Our contractual obligations.
                </li>
                <li>
                  <strong>Legal obligation</strong> - This is where We have to
                  process Personal Data in order to comply with the law.
                </li>
                <li>
                  <strong>Protection of vital interests</strong> - This is where
                  We are constrained to process your Personal Data in order to
                  protect your interests or those of another person, such as to
                  prevent identity theft.
                </li>
                <li>
                  <strong>Public interest</strong> - This is where there is an
                  overriding public interest, or We have been vested with an
                  official public mandate to take certain action in the interest
                  of the public.
                </li>
                <li>
                  <strong>Legitimate/Commercial interest</strong> - This is
                  where We process Personal Data in order to protect Our
                  legitimate/commercial interest.
                </li>
              </ol>
              <br />

              <h2>How Do We Use your Personal Data?</h2>
              <p>
                Shuttlers acts as a Data Controller when using your Personal
                Data in providing you with Services. We use Personal Data about
                you in the following ways:
              </p>
              <ol class="list-roman">
                <li>to provide you access to Our Services;</li>
                <li>
                  to improve and maintain performance of the App, by ensuring
                  that the content on the App is presented in the most effective
                  manner for you;
                </li>
                <li>
                  to provide you with data about services that you request from
                  Us or which We feel may interest you, where you have consented
                  to be contacted for such purposes;
                </li>
                <li>for statistical analysis or market research;</li>
                <li>to develop and improve Our Services;</li>
                <li>to update Our records;</li>
                <li>
                  to detect, investigate, prevent, or tackle illegal activities,
                  fraud, or situations involving potential threats to the
                  rights, property, or personal safety of Data Subject;
                </li>
                <li>
                  to ensure Our compliance with Our policies, terms, and other
                  applicable laws and regulations;
                </li>
                <li>to respond to inquiries and offer support to you;</li>
                <li>
                  to request your feedback and improve your user experience;
                </li>
                <li>
                  to carry out Our obligations arising from and exercise Our
                  rights under any agreements between you and Us;
                </li>
                <li>
                  to allow you to participate in interactive features of our
                  Services, when you choose to do so;
                </li>
                <li>
                  to notify you about changes to Our Services or potential new
                  services that We may offer;
                </li>
                <li>to provide you with customer service;</li>
                <li>for any legitimate business Interest;</li>
                <li>
                  recruitment - If you apply for a role via one of Our sites, We
                  will process your information in order to facilitate the
                  application process;
                </li>
                <li>
                  to process and assess your application for employment with Us;
                  and
                </li>
                <li>
                  in any other way that you have specifically consented to.
                </li>
              </ol>
              <br />
              <p>
                Shuttlers does not sell, rent or lease its customer lists to
                third parties.
              </p>
              <br />
              <p>
                Shuttlers may, from time to time, contact you on behalf of
                external business partners about a particular offer or update
                that you may be interested in. In these cases, your Personal
                Data will not be not transferred to such third party. Shuttlers
                may share your Personal Data with trusted partners (we rely upon
                to assist in the operation of the Services available to you) to
                help perform statistical analysis, send you email or postal
                mail, provide customer support, or arrange for deliveries. All
                such third parties are prohibited from using and exploiting your
                Personal Data except to enable Shuttlers provide the Services to
                you, and they are also required to maintain the confidentiality
                of your Personal Data.
              </p>
              <br />
              <p>
                Shuttlers may keep track of the websites and pages its users
                visit within Shuttlers, in order to determine what Shuttlers'
                services are the most popular and appealing to users. This data
                is used to deliver customised content and advertising within
                Shuttlers to users whose behavior indicates that they are
                interested in a particular subject area.
              </p>
              <br />

              <h2>Who We share your Personal Data with?</h2>
              <p>
                We do not share Personal Data with unaffiliated third parties,
                except as necessary for Our legitimate business interest, to
                provide you with Our Services, and/or as required or permitted
                by law or professional standards and generally to facilitate the
                running of Our business or to provide specific services you have
                requested. We would only transfer Personal Data to the following
                categories or situations, when they meet Our strict standards on
                the processing of data and security. We only share Personal Data
                that is necessary for them to provide their services. Shuttlers
                will not transfer your Personal Data to any third parties for
                their own direct marketing use except as stated herein.
                Commonly, We may share your Personal Data with:
              </p>
              <ol class="list-decimal">
                <li>
                  <strong>Service providers</strong> - We engage service
                  providers who help to support Our business and improve Our
                  products. These service providers may include payment
                  processors, customer service agencies, hosts, organizers and
                  sponsors of Our events; organizations that host Our website,
                  App or databases and providers of online surveys. We have
                  contracts in place with these data processors and they can
                  only use your Personal Data under Our instruction.
                </li>
                <li>
                  <strong>Advertisers</strong> - We, and Our advertising
                  partners, use cookies to collect Personal Data and serve you
                  with advertisements that We believe are relevant to you and
                  your interests.
                </li>
                <li>
                  <strong>Audits</strong> - disclosures of Personal Data may
                  also be needed for data privacy, financial or security audits
                  and/or to investigate or respond to a complaint or security
                  threat.
                </li>
                <li>
                  <strong>Legal processes and successors in title</strong> - We,
                  and Our suppliers, may also disclose your Personal Data to
                  comply with applicable laws, court orders or other valid legal
                  processes, and to enforce or apply Our terms of use, any
                  subscription agreement, or any of Our other rights. We may
                  transfer or disclose your Personal Data to any entity which
                  takes over or acquires the relevant Shuttlers company. We also
                  share aggregated, non-identifiable information with third
                  parties. Before sharing this information, We ensure that it
                  cannot identify you as an individual. For example, We may
                  share information about the size and growth of Our customer
                  base with investors.
                </li>
              </ol>
              <br />
              <h2>How long We retain your Personal Data?</h2>
              <p>
                We retain your Personal Data for as long as your account is
                active and therefore open; this allows you to continue accessing
                Our content, products and Services.
              </p>
              <br />
              <p>
                If you become inactive and are not a subscriber, We retain your
                Personal Data only for the period within which it is reasonably
                needed and may delete elements of your Personal Data associated
                with your account. We will normally warn you if your access is
                going to be withdrawn and give you the opportunity to retain
                your account.
              </p>
              <br />
              <p>
                Where We don't need to keep all of your Personal Data in full,
                We may obfuscate or aggregate it, for example, web activity logs
                and survey responses. This is to ensure that We do not retain
                your Personal Data for any longer than is necessary.
              </p>
              <p>
                It is sometimes necessary for Us to keep your Personal Data for
                longer periods of time, for example:
              </p>
              <ol class="list-decimal">
                <li>If there is a statutory requirement to retain it;</li>
                <li>
                  If We require the Personal Data for legal reasons or there is
                  a legitimate business need for Us to retain same;
                </li>
                <li>
                  To ensure We do not contact you if you have asked Us not to;
                  and
                </li>
                <li>
                  To use aggregated data derived from incorporating your
                  Personal Data after your user account becomes inactive, but
                  not in a manner that would identify you personally.
                </li>
              </ol>
              <h2>How Do We Secure and Store Personal Data?</h2>
              <p>
                We employ all reasonable efforts to keep your Personal Data
                secure by taking appropriate technical and organizational
                measures against its unauthorized or unlawful processing and
                against its accidental loss, destruction or damage. We store and
                process your Personal Data on Our computers in Nigeria. Where We
                need to transfer your Personal Data to another country, We would
                take reasonable steps to ensure that such country has an
                adequate data protection law. You hereby consent to the transfer
                of your Personal Data to countries which may not be on the white
                list specified by the NDPR where such transfers become expedient
                for us. We protect your Personal Data using physical, technical,
                and administrative security measures to reduce the risks of
                loss, misuse, unauthorized access, disclosure and alteration.
                Some of the safeguards We use are firewalls and data encryption,
                physical access controls to Our data centers, and information
                access authorization controls.
              </p>
              <br />
              <p>
                However, no data transmission over the internet or wireless
                network can be 100% guaranteed. Therefore, whilst We strive to
                protect your Personal Data, you acknowledge that:
              </p>
              <ol class="list-decimal">
                <li>
                  there are security and privacy limitations of the internet
                  which are beyond Our control;
                </li>
                <li>
                  the security, integrity, and privacy of any and all
                  information and data exchanged between you and Us cannot be
                  100% guaranteed; and
                </li>
                <li>
                  any such information and data may be viewed or tampered with
                  in transit by a third party, despite Our best efforts.
                </li>
              </ol>
              <h2>Data Breach</h2>
              <p>
                In the event We become aware that the security of Our Services
                have been compromised or users' Personal Information have been
                disclosed to unrelated third parties as a result of an external
                activity, including, but not limited to, security attacks or
                fraud, We reserve the right to take reasonably appropriate
                measures, including, but not limited to, investigation and
                reporting, as well as notification to and cooperation with law
                enforcement authorities. In the event of a data breach, We will
                make reasonable efforts to notify affected individuals if We
                believe that there is a reasonable risk of harm to the user as a
                result of the breach.
              </p>
              <br />
              <h2>Opt-Out &#38; Unsubscribe</h2>
              <p>
                We respect your privacy and give you an opportunity to opt-out
                of receiving announcements of certain information. You may
                opt-out of receiving any or all communications from Shuttlers by
                contacting Us at info@shuttlers.ng.
              </p>
              <br />
              <h2>
                What Happens When You Provide Us With Information About Others?
              </h2>
              <p>
                If you provide Us with Personal Data about another individual,
                you are responsible for ensuring that you comply with any
                obligation and consent obligations under applicable data
                protection laws in relation to such disclosure. Insofar as
                required by applicable data protection laws, you must ensure
                that you have provided the required notices and have obtained
                the individual's explicit consent to provide Us with the
                information and that you explain to them how We collect, use,
                disclose and retain their Personal Data or direct them to read
                Our Privacy Statement
              </p>

              <br />

              <p>
                For general enquiries regarding this Privacy Statement, or to
                make a request or complain about how We process Personal Data,
                you may contact Us at:
              </p>

              <p>
                No 10a Ojora Close, Off Idowu Martins, Victoria Island, Lagos
              </p>
              <p>
                <a class="text-active" href="mailto:info@shuttlers.ng"
                  >info@shuttlers.ng</a
                >
              </p>
              <p>
                Phone: <a href="tel:+234(0)7000700080">+234(0)7000700080</a>
              </p>
              <br />
            </div>
          </article>
        </div>
      </div>
    </div>
    <!-- <site-footer></site-footer> -->
  </div>
</template>

<script>
export default {
  head: {
    title: "Shuttlers - Privacy Policy",
    meta: [
      {
        hid: "description",
        name: "description",
        content:
          "Protecting your private information is our priority. This Statement of Privacy applies to the Shuttlers.ng and Shuttlers Logistics Company and governs data collection and usage.",
      },
    ],
  },
};
</script>

<style scoped>
/* cspell:disable-file */
/* webkit printing magic: print all background colors */
html {
  -webkit-print-color-adjust: exact;
}
* {
  box-sizing: border-box;
  -webkit-print-color-adjust: exact;
}

html,
body {
  margin: 0;
  padding: 0;
}
@media only screen {
  body {
    margin: 2em auto;
    max-width: 900px;
    color: rgb(55, 53, 47);
  }
}

body {
  line-height: 1.5;
  white-space: pre-wrap;
}

a,
a.visited {
  color: inherit;
  text-decoration: underline;
}

.pdf-relative-link-path {
  font-size: 80%;
  color: #444;
}

h1,
h2,
h3 {
  letter-spacing: -0.01em;
  line-height: 1.2;
  font-weight: 600;
  margin-bottom: 0;
}

.page-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 0.75em;
}

h1 {
  font-size: 1.875rem;
  margin-top: 1.875rem;
}

h2 {
  font-size: 1.5rem;
  margin-top: 1.5rem;
}

h3 {
  font-size: 1.25rem;
  margin-top: 1.25rem;
}

.source {
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 1.5em;
  word-break: break-all;
}

.callout {
  border-radius: 3px;
  padding: 1rem;
}

figure {
  margin: 1.25em 0;
  page-break-inside: avoid;
}

figcaption {
  opacity: 0.5;
  font-size: 85%;
  margin-top: 0.5em;
}

mark {
  background-color: transparent;
}

.indented {
  padding-left: 1.5em;
}

hr {
  background: transparent;
  display: block;
  width: 100%;
  height: 1px;
  visibility: visible;
  border: none;
  border-bottom: 1px solid rgba(55, 53, 47, 0.09);
}

img {
  max-width: 100%;
}

@media only print {
  img {
    max-height: 100vh;
    object-fit: contain;
  }
}

@page {
  margin: 1in;
}

.collection-content {
  font-size: 0.875rem;
}

.column-list {
  display: flex;
  justify-content: space-between;
}

.column {
  padding: 0 1em;
}

.column:first-child {
  padding-left: 0;
}

.column:last-child {
  padding-right: 0;
}

.table_of_contents-item {
  display: block;
  font-size: 0.875rem;
  line-height: 1.3;
  padding: 0.125rem;
}

.table_of_contents-indent-1 {
  margin-left: 1.5rem;
}

.table_of_contents-indent-2 {
  margin-left: 3rem;
}

.table_of_contents-indent-3 {
  margin-left: 4.5rem;
}

.table_of_contents-link {
  text-decoration: none;
  opacity: 0.7;
  border-bottom: 1px solid rgba(55, 53, 47, 0.18);
}

table,
th,
td {
  border: 1px solid rgba(55, 53, 47, 0.09);
  border-collapse: collapse;
}

table {
  border-left: none;
  border-right: none;
}

th,
td {
  font-weight: normal;
  padding: 0.25em 0.5em;
  line-height: 1.5;
  min-height: 1.5em;
  text-align: left;
}

th {
  color: rgba(55, 53, 47, 0.6);
}

ol,
ul {
  margin: 0;
  margin-block-start: 0.6em;
  margin-block-end: 0.6em;
}

li > ol:first-child,
li > ul:first-child {
  margin-block-start: 0.6em;
}

ul > li {
  list-style: disc;
}

ul.to-do-list {
  text-indent: -1.7em;
}

ul.to-do-list > li {
  list-style: none;
}

.to-do-children-checked {
  text-decoration: line-through;
  opacity: 0.375;
}

ul.toggle > li {
  list-style: none;
}

ul {
  padding-inline-start: 1.7em;
}

ul > li {
  padding-left: 0.1em;
}

ol {
  padding-inline-start: 1.6em;
}

ol > li {
  padding-left: 0.2em;
}

.mono ol {
  padding-inline-start: 2em;
}

.mono ol > li {
  text-indent: -0.4em;
}

.toggle {
  padding-inline-start: 0em;
  list-style-type: none;
}

/* Indent toggle children */
.toggle > li > details {
  padding-left: 1.7em;
}

.toggle > li > details > summary {
  margin-left: -1.1em;
}

.selected-value {
  display: inline-block;
  padding: 0 0.5em;
  background: rgba(206, 205, 202, 0.5);
  border-radius: 3px;
  margin-right: 0.5em;
  margin-top: 0.3em;
  margin-bottom: 0.3em;
  white-space: nowrap;
}

.collection-title {
  display: inline-block;
  margin-right: 1em;
}

.simple-table {
  margin-top: 1em;
  font-size: 0.875rem;
}

.simple-table-header {
  background: rgb(247, 246, 243);
  color: black;
  font-weight: 500;
}

time {
  opacity: 0.5;
}

.icon {
  display: inline-block;
  max-width: 1.2em;
  max-height: 1.2em;
  text-decoration: none;
  vertical-align: text-bottom;
  margin-right: 0.5em;
}

img.icon {
  border-radius: 3px;
}

.user-icon {
  width: 1.5em;
  height: 1.5em;
  border-radius: 100%;
  margin-right: 0.5rem;
}

.user-icon-inner {
  font-size: 0.8em;
}

.text-icon {
  border: 1px solid #000;
  text-align: center;
}

.page-cover-image {
  display: block;
  object-fit: cover;
  width: 100%;
  max-height: 30vh;
}

.page-header-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.page-header-icon-with-cover {
  margin-top: -0.72em;
  margin-left: 0.07em;
}

.page-header-icon img {
  border-radius: 3px;
}

.link-to-page {
  margin: 1em 0;
  padding: 0;
  border: none;
  font-weight: 500;
}

p > .user {
  opacity: 0.5;
}

td > .user,
td > time {
  white-space: nowrap;
}

input[type="checkbox"] {
  transform: scale(1.5);
  margin-right: 0.6em;
  vertical-align: middle;
}

p {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

.image {
  border: none;
  margin: 1.5em 0;
  padding: 0;
  border-radius: 0;
  text-align: center;
}

.code,
code {
  background: rgba(135, 131, 120, 0.15);
  border-radius: 3px;
  padding: 0.2em 0.4em;
  border-radius: 3px;
  font-size: 85%;
  tab-size: 2;
}

code {
  color: #eb5757;
}

.code {
  padding: 1.5em 1em;
}

.code-wrap {
  white-space: pre-wrap;
  word-break: break-all;
}

.code > code {
  background: none;
  padding: 0;
  font-size: 100%;
  color: inherit;
}

blockquote {
  font-size: 1.25em;
  margin: 1em 0;
  padding-left: 1em;
  border-left: 3px solid rgb(55, 53, 47);
}

.bookmark {
  text-decoration: none;
  max-height: 8em;
  padding: 0;
  display: flex;
  width: 100%;
  align-items: stretch;
}

.bookmark-title {
  font-size: 0.85em;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 1.75em;
  white-space: nowrap;
}

.bookmark-text {
  display: flex;
  flex-direction: column;
}

.bookmark-info {
  flex: 4 1 180px;
  padding: 12px 14px 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.bookmark-image {
  width: 33%;
  flex: 1 1 180px;
  display: block;
  position: relative;
  object-fit: cover;
  border-radius: 1px;
}

.bookmark-description {
  color: rgba(55, 53, 47, 0.6);
  font-size: 0.75em;
  overflow: hidden;
  max-height: 4.5em;
  word-break: break-word;
}

.bookmark-href {
  font-size: 0.75em;
  margin-top: 0.25em;
}

.sans {
  font-family: ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI",
    Helvetica, "Apple Color Emoji", Arial, sans-serif, "Segoe UI Emoji",
    "Segoe UI Symbol";
}
.code {
  font-family: "SFMono-Regular", Menlo, Consolas, "PT Mono", "Liberation Mono",
    Courier, monospace;
}
.serif {
  font-family: Lyon-Text, Georgia, ui-serif, serif;
}
.mono {
  font-family: iawriter-mono, Nitti, Menlo, Courier, monospace;
}
.pdf .sans {
  font-family: Inter, ui-sans-serif, -apple-system, BlinkMacSystemFont,
    "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif,
    "Segoe UI Emoji", "Segoe UI Symbol", "Twemoji", "Noto Color Emoji",
    "Noto Sans CJK JP";
}
.pdf:lang(zh-CN) .sans {
  font-family: Inter, ui-sans-serif, -apple-system, BlinkMacSystemFont,
    "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif,
    "Segoe UI Emoji", "Segoe UI Symbol", "Twemoji", "Noto Color Emoji",
    "Noto Sans CJK SC";
}
.pdf:lang(zh-TW) .sans {
  font-family: Inter, ui-sans-serif, -apple-system, BlinkMacSystemFont,
    "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif,
    "Segoe UI Emoji", "Segoe UI Symbol", "Twemoji", "Noto Color Emoji",
    "Noto Sans CJK TC";
}
.pdf:lang(ko-KR) .sans {
  font-family: Inter, ui-sans-serif, -apple-system, BlinkMacSystemFont,
    "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif,
    "Segoe UI Emoji", "Segoe UI Symbol", "Twemoji", "Noto Color Emoji",
    "Noto Sans CJK KR";
}
.pdf .code {
  font-family: Source Code Pro, "SFMono-Regular", Menlo, Consolas, "PT Mono",
    "Liberation Mono", Courier, monospace, "Twemoji", "Noto Color Emoji",
    "Noto Sans Mono CJK JP";
}
.pdf:lang(zh-CN) .code {
  font-family: Source Code Pro, "SFMono-Regular", Menlo, Consolas, "PT Mono",
    "Liberation Mono", Courier, monospace, "Twemoji", "Noto Color Emoji",
    "Noto Sans Mono CJK SC";
}
.pdf:lang(zh-TW) .code {
  font-family: Source Code Pro, "SFMono-Regular", Menlo, Consolas, "PT Mono",
    "Liberation Mono", Courier, monospace, "Twemoji", "Noto Color Emoji",
    "Noto Sans Mono CJK TC";
}
.pdf:lang(ko-KR) .code {
  font-family: Source Code Pro, "SFMono-Regular", Menlo, Consolas, "PT Mono",
    "Liberation Mono", Courier, monospace, "Twemoji", "Noto Color Emoji",
    "Noto Sans Mono CJK KR";
}
.pdf .serif {
  font-family: PT Serif, Lyon-Text, Georgia, ui-serif, serif, "Twemoji",
    "Noto Color Emoji", "Noto Serif CJK JP";
}
.pdf:lang(zh-CN) .serif {
  font-family: PT Serif, Lyon-Text, Georgia, ui-serif, serif, "Twemoji",
    "Noto Color Emoji", "Noto Serif CJK SC";
}
.pdf:lang(zh-TW) .serif {
  font-family: PT Serif, Lyon-Text, Georgia, ui-serif, serif, "Twemoji",
    "Noto Color Emoji", "Noto Serif CJK TC";
}
.pdf:lang(ko-KR) .serif {
  font-family: PT Serif, Lyon-Text, Georgia, ui-serif, serif, "Twemoji",
    "Noto Color Emoji", "Noto Serif CJK KR";
}
.pdf .mono {
  font-family: PT Mono, iawriter-mono, Nitti, Menlo, Courier, monospace,
    "Twemoji", "Noto Color Emoji", "Noto Sans Mono CJK JP";
}
.pdf:lang(zh-CN) .mono {
  font-family: PT Mono, iawriter-mono, Nitti, Menlo, Courier, monospace,
    "Twemoji", "Noto Color Emoji", "Noto Sans Mono CJK SC";
}
.pdf:lang(zh-TW) .mono {
  font-family: PT Mono, iawriter-mono, Nitti, Menlo, Courier, monospace,
    "Twemoji", "Noto Color Emoji", "Noto Sans Mono CJK TC";
}
.pdf:lang(ko-KR) .mono {
  font-family: PT Mono, iawriter-mono, Nitti, Menlo, Courier, monospace,
    "Twemoji", "Noto Color Emoji", "Noto Sans Mono CJK KR";
}
.highlight-default {
  color: rgba(55, 53, 47, 1);
}
.highlight-gray {
  color: rgba(120, 119, 116, 1);
  fill: rgba(145, 145, 142, 1);
}
.highlight-brown {
  color: rgba(159, 107, 83, 1);
  fill: rgba(187, 132, 108, 1);
}
.highlight-orange {
  color: rgba(217, 115, 13, 1);
  fill: rgba(215, 129, 58, 1);
}
.highlight-yellow {
  color: rgba(203, 145, 47, 1);
  fill: rgba(203, 148, 51, 1);
}
.highlight-teal {
  color: rgba(68, 131, 97, 1);
  fill: rgba(108, 155, 125, 1);
}
.highlight-blue {
  color: rgba(51, 126, 169, 1);
  fill: rgba(91, 151, 189, 1);
}
.highlight-purple {
  color: rgba(144, 101, 176, 1);
  fill: rgba(167, 130, 195, 1);
}
.highlight-pink {
  color: rgba(193, 76, 138, 1);
  fill: rgba(205, 116, 159, 1);
}
.highlight-red {
  color: rgba(212, 76, 71, 1);
  fill: rgba(225, 111, 100, 1);
}
.highlight-gray_background {
  background: rgba(241, 241, 239, 1);
}
.highlight-brown_background {
  background: rgba(244, 238, 238, 1);
}
.highlight-orange_background {
  background: rgba(251, 236, 221, 1);
}
.highlight-yellow_background {
  background: rgba(251, 243, 219, 1);
}
.highlight-teal_background {
  background: rgba(237, 243, 236, 1);
}
.highlight-blue_background {
  background: rgba(231, 243, 248, 1);
}
.highlight-purple_background {
  background: rgba(244, 240, 247, 0.8);
}
.highlight-pink_background {
  background: rgba(249, 238, 243, 0.8);
}
.highlight-red_background {
  background: rgba(253, 235, 236, 1);
}
.block-color-default {
  color: inherit;
  fill: inherit;
}
.block-color-gray {
  color: rgba(120, 119, 116, 1);
  fill: rgba(145, 145, 142, 1);
}
.block-color-brown {
  color: rgba(159, 107, 83, 1);
  fill: rgba(187, 132, 108, 1);
}
.block-color-orange {
  color: rgba(217, 115, 13, 1);
  fill: rgba(215, 129, 58, 1);
}
.block-color-yellow {
  color: rgba(203, 145, 47, 1);
  fill: rgba(203, 148, 51, 1);
}
.block-color-teal {
  color: rgba(68, 131, 97, 1);
  fill: rgba(108, 155, 125, 1);
}
.block-color-blue {
  color: rgba(51, 126, 169, 1);
  fill: rgba(91, 151, 189, 1);
}
.block-color-purple {
  color: rgba(144, 101, 176, 1);
  fill: rgba(167, 130, 195, 1);
}
.block-color-pink {
  color: rgba(193, 76, 138, 1);
  fill: rgba(205, 116, 159, 1);
}
.block-color-red {
  color: rgba(212, 76, 71, 1);
  fill: rgba(225, 111, 100, 1);
}
.block-color-gray_background {
  background: rgba(241, 241, 239, 1);
}
.block-color-brown_background {
  background: rgba(244, 238, 238, 1);
}
.block-color-orange_background {
  background: rgba(251, 236, 221, 1);
}
.block-color-yellow_background {
  background: rgba(251, 243, 219, 1);
}
.block-color-teal_background {
  background: rgba(237, 243, 236, 1);
}
.block-color-blue_background {
  background: rgba(231, 243, 248, 1);
}
.block-color-purple_background {
  background: rgba(244, 240, 247, 0.8);
}
.block-color-pink_background {
  background: rgba(249, 238, 243, 0.8);
}
.block-color-red_background {
  background: rgba(253, 235, 236, 1);
}
.select-value-color-pink {
  background-color: rgba(245, 224, 233, 1);
}
.select-value-color-purple {
  background-color: rgba(232, 222, 238, 1);
}
.select-value-color-green {
  background-color: rgba(219, 237, 219, 1);
}
.select-value-color-gray {
  background-color: rgba(227, 226, 224, 1);
}
.select-value-color-orange {
  background-color: rgba(250, 222, 201, 1);
}
.select-value-color-brown {
  background-color: rgba(238, 224, 218, 1);
}
.select-value-color-red {
  background-color: rgba(255, 226, 221, 1);
}
.select-value-color-yellow {
  background-color: rgba(253, 236, 200, 1);
}
.select-value-color-blue {
  background-color: rgba(211, 229, 239, 1);
}

.checkbox {
  display: inline-flex;
  vertical-align: text-bottom;
  width: 16;
  height: 16;
  background-size: 16px;
  margin-left: 2px;
  margin-right: 5px;
}

.checkbox-on {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22%2358A9D7%22%2F%3E%0A%3Cpath%20d%3D%22M6.71429%2012.2852L14%204.9995L12.7143%203.71436L6.71429%209.71378L3.28571%206.2831L2%207.57092L6.71429%2012.2852Z%22%20fill%3D%22white%22%2F%3E%0A%3C%2Fsvg%3E");
}

.checkbox-off {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Crect%20x%3D%220.75%22%20y%3D%220.75%22%20width%3D%2214.5%22%20height%3D%2214.5%22%20fill%3D%22white%22%20stroke%3D%22%2336352F%22%20stroke-width%3D%221.5%22%2F%3E%0A%3C%2Fsvg%3E");
}
</style>